module.exports = __webpack_public_path__ + "static/torchmiddle-a74aabb81a4fbc7a6990dda48e635a4a.jpg";